module.exports = require("@pb/kit-component-animation");